import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./LoginPage";
import ItemGroup from "./CartGroup";
import CartItem from "./CartItem";

function App() {
  return (
      <ItemGroup/>
    // <BrowserRouter>
    //   <Routes>
    //     {/* <Route path="/" element={<Login />} /> */}
    //     <Route path="/" element={<ItemGroup />} />
    //     <Route path="/cartitem" element={<CartItem />} />
    //   </Routes>
    // </BrowserRouter>
  );
}

export default App;
